<template>
  <div class="excellent-service">
    <div class="service-header">
      <div class="title">优质服务</div>

      <!-- 服务特点 -->
      <div class="service-features">
        <div class="feature">
          <div class="feature-icon">
            <img
              src="@/assets/first/fullProcessCoverage.svg"
              alt="全流程覆盖"
            />
          </div>
          <span>全流程覆盖</span>
        </div>
        <div class="feature">
          <div class="feature-icon">
            <img
              src="@/assets/first/quickResponseMechanism.svg"
              alt="快速响应机制"
            />
          </div>
          <span>快速响应机制</span>
        </div>
        <div class="feature">
          <div class="feature-icon">
            <img
              src="@/assets/first/personalizedService.svg"
              alt="个性化服务"
            />
          </div>
          <span>个性化服务</span>
        </div>
      </div>
    </div>

    <!-- 服务阶段 -->
    <div class="service-stages">
      <!-- 售前 -->
      <div class="stage normal-stage">
        <div class="stage-content">
          <div class="stage-image">
            <img
              src="@/assets/first/pre-sales.svg"
              alt="售前"
              class="main-image"
            />
          </div>
          <div class="stage-info">
            <div class="stage-number">01</div>
            <div class="stage-title">售前</div>
            <div class="stage-description">需求分析与方案定制</div>
          </div>
          <div class="after-sales-services">
            <div class="service-item">
              <img
                src="@/assets/first/requirementResearch.svg"
                alt="需求调研"
              />
              <span>需求调研</span>
            </div>
            <div class="service-item">
              <img src="@/assets/first/userTraining.svg" alt="现场踏勘" />
              <span>现场踏勘</span>
            </div>
            <div class="service-item">
              <img
                src="@/assets/first/technicalExpertConsultant.svg"
                alt="技术专家顾问"
              />
              <span>技术专家顾问</span>
            </div>
            <div class="service-item">
              <img
                src="@/assets/first/overallSolutionDesign.svg"
                alt="整体解决方案设计"
              />
              <span>整体解决方案设计</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 售中 -->
      <div class="stage normal-stage">
        <div class="stage-content">
          <div class="stage-image">
            <img src="@/assets/first/sell.svg" alt="售中" class="main-image" />
          </div>
          <div class="stage-info">
            <div class="stage-number">02</div>
            <div class="stage-title">售中</div>
            <div class="stage-description">技术方案实施</div>
          </div>
          <div class="after-sales-services">
            <div class="service-item">
              <img src="@/assets/first/detailedDesign.svg" alt="深化设计" />
              <span>深化设计</span>
            </div>
            <div class="service-item">
              <img
                src="@/assets/first/professionalProjectManagementTeam.svg"
                alt="专业的项目管理团队"
              />
              <span>专业的项目管理团队</span>
            </div>
            <div class="service-item">
              <img
                src="@/assets/first/selfDevelopedRapidDebuggingAndDeployment.svg"
                alt="自研快速调试部署工具"
              />
              <span>自研快速调试部署工具</span>
            </div>
            <div class="service-item">
              <img src="@/assets/first/userTraining.svg" alt="用户培训" />
              <span>用户培训</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 售后 -->
      <div class="stage wide-stage">
        <div class="stage-content">
          <div class="stage-image">
            <img
              src="@/assets/first/afterSales.svg"
              alt="售后"
              class="main-image"
            />
          </div>
          <div class="stage-info after-stage-info">
            <div class="stage-number">03</div>
            <div class="stage-title">售后</div>
            <div class="stage-description">全生命周期技术保障</div>
            <img
              src="@/assets/first/afterSales.svg"
              alt="售后"
              class="stage-icon"
            />
          </div>

          <!-- 售后服务项目 -->
          <div class="after-sales-services">
            <div class="service-item">
              <img
                src="@/assets/first/professionalAfter-salesServiceTeam.svg"
                alt="专业的售后服务团队"
              />
              <span>专业的售后服务团队</span>
            </div>
            <div class="service-item">
              <img
                src="@/assets/first/sparePartsWarehouse.svg"
                alt="品类齐全的备件库和专属备件库"
              />
              <span>品类齐全的备件库和专属备件库</span>
            </div>
            <div class="service-item">
              <img
                src="@/assets/first/inspectionServices.svg"
                alt="巡检服务+重保服务"
              />
              <span>巡检服务+重保服务</span>
            </div>
            <div class="service-item">
              <img src="@/assets/first/remoteService.svg" alt="现场+远程服务" />
              <span>现场+远程服务</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExcellentService",
};
</script>

<style scoped>
.excellent-service {
  background: linear-gradient(180deg, #f5f9ff 0%, #ffffff 100%);
  min-height: 800px;
  min-width: 1500px;
  padding-left: 100px;
}

.service-header {
  text-align: left;
  max-width: 1500px;
  /* margin: 0 auto; */
}

.title {
  padding-top: 60px;
  text-align: left;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 30px;
  font-family: Microsoft YaHei, Microsoft YaHei-700;
  font-weight: 700;
  text-align: LEFT;
  color: #2c3239;
  line-height: 36px;
}

.service-features {
  display: flex;
  gap: 120px;
  margin-bottom: 115px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 8px;
}

.feature-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.feature-icon img {
  width: 16px;
  height: 16px;
}

.feature span {
  height: 21px;
  font-size: 20px;
  font-family: Microsoft YaHei, Microsoft YaHei-400;
  font-weight: 400;
  text-align: LEFT;
  color: #2c3239;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.service-stages {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  /* margin: 0 auto; */
  max-width: 1580px;
}

.stage {
  position: relative;
  background: #ebf3fa;
  border-radius: 8px;
  height: 420px;
  overflow: hidden;
  cursor: pointer;
}

.stage.normal-stage {
  width: 300px !important;
  flex: none;
  transform-origin: right center;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage.normal-stage:hover {
  width: 740px !important;
  background: #f5f9ff;
  /* padding: 40px; */
}

.stage.normal-stage:hover .stage-content {
  height: auto;
  padding: 0 20px;
}

.stage.normal-stage:hover .stage-info {
  /* padding-left: 40px; */
}

.stage.normal-stage:hover ~ .wide-stage {
  width: 300px !important;
  background: #ebf3fa;
  padding: 0;
}

.stage.normal-stage:hover ~ .wide-stage .stage-info {
  padding-left: 20px;
  width: 240px;
  margin-right: auto;
}

.stage.normal-stage:hover .stage-image {
  position: absolute;
  right: 0;
  top: 0;
}

.stage.normal-stage:hover .after-sales-services {
  display: flex;
  justify-content: space-between;
  width: 100%;
  opacity: 1;
  visibility: visible;
}

.stage.normal-stage:hover .stage-content {
  height: auto;
}

.stage.wide-stage {
  width: 740px !important;
  flex: none;
  /* padding: 40px; */
  background: #f5f9ff;
  transform-origin: left center;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage-content {
  height: 240px;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage-image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 240px;
  height: 240px;
  border-radius: 8px;
  margin-left: auto;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.main-image {
  width: 240px;
  height: 240px;
  object-fit: contain;
}

.stage-info {
  position: relative;
  width: 240px;
  padding-left: 20px;
  margin-right: auto;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: left bottom;
}

.after-stage-info {
  width: 100%;
  padding-left: 20px;
  margin-right: 0;
  margin-bottom: 40px;
}

.stage-number {
  opacity: 0.3;
  font-size: 48px;
  font-family: DIN, DIN-700;
  font-weight: 700;
  text-align: LEFT;
  color: #0b5cfe;
  line-height: 48px;
  background: #0b5cfe;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 10px;
  transform: scale(1);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage-title {
  font-size: 28px;
  font-family: Microsoft YaHei, Microsoft YaHei-700;
  font-weight: 700;
  text-align: LEFT;
  color: #2c3239;
  line-height: 28px;
  transform: scale(1);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage-description {
  font-size: 24px;
  font-family: Microsoft YaHei, Microsoft YaHei-700;
  font-weight: 700;
  text-align: LEFT;
  color: #2c3239;
  line-height: 24px;
  padding-top: 15px;
  transform: scale(1);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage-icon {
  width: 240px;
  height: 240px;
  position: absolute;
  right: 0;
  top: 0;
}

.after-sales-services {
  display: flex;
  justify-content: space-between;
  padding-top: 100px;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  opacity: 1;
  transform: translateY(0);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage.normal-stage .after-sales-services {
  display: flex;
  opacity: 0;
  visibility: hidden;
  padding-top: 150px;
}

.stage.normal-stage .service-item {
  transform: translateY(30px);
}

.stage.normal-stage .service-item img {
  transform: translateY(20px) scale(0.8);
  opacity: 0;
}

.stage.normal-stage .service-item span {
  transform: translateY(20px);
  opacity: 0;
}

.stage.normal-stage:hover .after-sales-services {
  opacity: 1;
  visibility: visible;
}

.stage.normal-stage:hover .service-item,
.stage.normal-stage:hover .service-item img,
.stage.normal-stage:hover .service-item span {
  transform: translateY(0);
  opacity: 1;
}

.stage.normal-stage:hover .service-item img {
  transform: translateY(0) scale(1);
}

.stage.normal-stage:hover ~ .wide-stage .after-sales-services {
  opacity: 0;
  visibility: hidden;
}

.stage.normal-stage:hover ~ .wide-stage .service-item {
  transform: translateY(30px);
}

.stage.normal-stage:hover ~ .wide-stage .service-item img {
  transform: translateY(20px) scale(0.8);
  opacity: 0;
}

.stage.normal-stage:hover ~ .wide-stage .service-item span {
  transform: translateY(20px);
  opacity: 0;
}

.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  transform: translateY(0);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.service-item img {
  transform: translateY(0) scale(1);
  opacity: 1;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.service-item span {
  transform: translateY(0);
  opacity: 1;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.service-item img {
  width: 40px;
  height: 40px;
  filter: brightness(0) saturate(100%) invert(31%) sepia(97%) saturate(1029%)
    hue-rotate(197deg) brightness(103%) contrast(107%);
}

.service-item span {
  font-size: 14px;
  color: #666666;
  line-height: 1.4;
  max-width: 120px;
}

@media (max-width: 1580px) {
  .service-stages {
    max-width: 1580px;
    margin: 0 auto;
  }

  .stage.normal-stage,
  .stage.wide-stage {
    width: 300px !important;
  }

  .stage.wide-stage {
    width: 740px !important;
  }
}

@media (max-width: 768px) {
  .service-header {
    max-width: 1580px;
    margin: 0 auto;
  }

  .title {
    text-align: left;
  }

  .service-features {
    flex-direction: row;
    align-items: center;
    gap: 120px;
  }
}

.stage.normal-stage:hover + .normal-stage,
.stage.normal-stage:hover ~ .wide-stage {
  width: 300px !important;
  background: #ebf3fa;
  padding: 0;
  transition: all 0.3s ease;
}

.stage.normal-stage:hover ~ .wide-stage .after-sales-services {
  display: none;
}

.stage.normal-stage:hover ~ .wide-stage .after-stage-info {
  width: 240px;
  padding-left: 20px;
  margin-right: auto;
  margin-bottom: 0;
}

.stage.normal-stage:hover ~ .wide-stage .stage-icon {
  display: none;
}

.stage.wide-stage .stage-image {
  display: none;
}

.stage.normal-stage:hover ~ .wide-stage .stage-image {
  display: flex;
}

.stage.normal-stage:hover ~ .wide-stage .stage-content {
  height: 240px;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* 为每个service-item添加延迟动画 */
.service-item:nth-child(1) {
  transition-delay: 0.2s;
}
.service-item:nth-child(1) img {
  transition-delay: 0.3s;
}
.service-item:nth-child(1) span {
  transition-delay: 0.4s;
}

.service-item:nth-child(2) {
  transition-delay: 0.3s;
}
.service-item:nth-child(2) img {
  transition-delay: 0.4s;
}
.service-item:nth-child(2) span {
  transition-delay: 0.5s;
}

.service-item:nth-child(3) {
  transition-delay: 0.4s;
}
.service-item:nth-child(3) img {
  transition-delay: 0.5s;
}
.service-item:nth-child(3) span {
  transition-delay: 0.6s;
}

.service-item:nth-child(4) {
  transition-delay: 0.5s;
}
.service-item:nth-child(4) img {
  transition-delay: 0.6s;
}
.service-item:nth-child(4) span {
  transition-delay: 0.7s;
}

.stage.normal-stage .stage-number {
  transform: scale(1);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage.normal-stage .stage-title {
  transform: scale(1);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage.normal-stage .stage-description {
  transform: scale(1);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage.normal-stage:hover .stage-number {
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 0.1s;
}

.stage.normal-stage:hover .stage-title {
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 0.2s;
}

.stage.normal-stage:hover .stage-description {
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 0.3s;
}

.stage.normal-stage:hover ~ .wide-stage .stage-number {
  transform: scale(1);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage.normal-stage:hover ~ .wide-stage .stage-title {
  transform: scale(1);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage.normal-stage:hover ~ .wide-stage .stage-description {
  transform: scale(1);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage.normal-stage .stage-info {
  /* transform: translateY(180px); */
}

.stage.normal-stage:hover .stage-info {
  /* transform: translateY(0); */
}

.stage.normal-stage:hover ~ .wide-stage .stage-info {
  padding-left: 20px;
  width: 240px;
  margin-right: auto;
}
</style>
